<template>
	<div
		v-if="rating > 0"
		class="rating-view"
	>
		<span
			class="rating-view__rating"
			:class="{ 'is-hidden': rating === 0 }"
		>
			{{ rating }}
		</span>
		<Icon
			icon-name="star-filled"
			size="sm"
		/>
	</div>
</template>

<script>
import Icon from '@components/Icon';

export default {
	name:       'RatingView',
	components: { Icon },
	props:      {
		rating: {
			type:    Number,
			default: 0,
		},
	},
};
</script>

<style lang="scss" scoped>
.rating-view {
	position: relative;
    height: 24px;
 	display: flex;
	gap: 4px;
	text-align: center;
    justify-content: center;
    align-items: center;
}

.rating-view__rating {
	font-size: 14px;

	&.is-hidden {
		visibility: hidden;
	}
}
</style>
